<div class="overflow-hidden rounded-lg bg-white dark:bg-gray-900/20 shadow-sm font-header">
  <div class="text-center grid grid-cols-2 items-center">
    <div class="relative">
      <p class="p-6 text-2xl leading-none text-primary-500 dark:text-white">
        Come for a
        <span class="italic font-accent text-6xl text-villages-gold-500 block leading-14"
          >lifestyle preview</span
        >
        Experience
      </p>

      <button
        type="button"
        class="rounded-md bg-primary-500 text-white px-8 py-6 text-lg font-semibold shadow-xs inset-ring inset-ring-gray-300 dark:inset-ring-gray-700 hover:bg-primary-700 mt-2 cursor-pointer"
        (click)="lppClicked.emit()"
      >
        Learn More
      </button>

      <div
        class="absolute -bottom-12 -right-32 w-36 h-36 lg:w-48 lg:h-48 bg-gray-200 dark:bg-gray-800 rounded-full text-sm lg:text-md flex flex-col items-center justify-center text-primary-500 dark:text-gray-500 border-8 border-white dark:border-gray-900/20"
      >
        Starting at
        <span class="block text-3xl lg:text-4xl leading-tight"
          >${{ price() }}<sup class="text-xl">*</sup></span
        >
        per day
      </div>
    </div>

    <img [src]="image()" alt="The Villages Lifestyle Preview" class="h-full object-cover" />
  </div>

  <div
    class="px-4 pt-12 pb-5 sm:px-6 sm:ty-12 sm:pb-6 text-center text-xs text-gray-600 dark:text-gray-500 font-body"
    [innerHTML]="footnote()"
  ></div>
</div>
